// components/MonthlyVisitsChart.jsx
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const MonthlyVisitsChart = ({ data }) => {
  return (
    <div style={{ width: '100%', height: 300 }}>
      <h3>Trend des visites mensuelles</h3>
      <ResponsiveContainer>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#00ff00" />
          <XAxis dataKey="monthYear" stroke="#00ff00" />
          <YAxis stroke="#00ff00" />
          <Tooltip contentStyle={{ backgroundColor: '#111', borderColor: '#00ff00' }} />
          <Legend />
          <Line type="monotone" dataKey="visitCount" stroke="#ff0" activeDot={{ r: 8 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MonthlyVisitsChart;
